import { z } from "zod";

/**
 * パスワード強度の共通仕様: 8 文字以上 + 英字 + 数字。
 * auth-relay（updatePassword）のサーバー側検証と同じルールにそろえる。
 */
const passwordSchema = z
  .string()
  .min(8, "パスワードは8文字以上で設定してください。")
  .regex(/[a-zA-Z]/, "パスワードは英字を含む必要があります。")
  .regex(/\d/, "パスワードは数字を含む必要があります。");

/**
 * 命令的バリデーション（SetPassword コンポーネント用）。
 * 問題がなければ null、あれば最初のエラーメッセージを返す。
 */
export const validatePassword = (password: string): string | null => {
  const result = passwordSchema.safeParse(password);
  if (!result.success) {
    return result.error.issues[0]?.message ?? "パスワードが不正です。";
  }
  return null;
};
